import { Button } from '@core/ui';
import { EditProfileFormCancelButtonProps } from './types';

export const EditProfileFormCancelButton = ({ children, ...props }: EditProfileFormCancelButtonProps) => {
    return (
        <Button variant="primary-outline" {...props}>
            {children}
        </Button>
    );
};
